import { render, staticRenderFns } from "./DLGContentDetailEdit.vue?vue&type=template&id=c5137934&scoped=true&"
import script from "./DLGContentDetailEdit.vue?vue&type=script&lang=js&"
export * from "./DLGContentDetailEdit.vue?vue&type=script&lang=js&"
import style0 from "./DLGContentDetailEdit.vue?vue&type=style&index=0&id=c5137934&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5137934",
  null
  
)

export default component.exports